import React, { useEffect, useState } from "react";
import "./reglamentos.css";

function Reglamentos() {
    const [lista, setLista] = useState([]);
    const [error, setError] = useState("");

    // Modal Subir
    const [showUp, setShowUp] = useState(false);
    const [upNombre, setUpNombre] = useState("");
    const [upFecha, setUpFecha] = useState(() => {
        const d = new Date();
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    });
    const [upFile, setUpFile] = useState(null);
    const [subiendo, setSubiendo] = useState(false);

    // Modal Confirmar eliminación
    const [confirmDel, setConfirmDel] = useState(null); // item o null

    const cargarLista = async () => {
        try {
            setError("");
            const r = await fetch("/api/reglamentos");
            if (!r.ok) throw new Error(await r.text());
            const data = await r.json();
            setLista(Array.isArray(data) ? data : []);
        } catch (e) {
            setError(e.message || "No se pudo cargar la lista");
        }
    };

    useEffect(() => {
        cargarLista();
    }, []);
    
    const descargar = async (item) => {
        try {
            const r = await fetch(`/api/reglamentos/${item._id}?download=1`);
            if (!r.ok) throw new Error(await r.text());
            const blob = await r.blob();
            const url = window.URL.createObjectURL(blob);
            const nombre =
                (item.nombre && `${item.nombre}.pdf`) ||
                item.filename ||
                `reglamento-${item._id}.pdf`;
            const a = document.createElement("a");
            a.href = url;
            a.download = nombre.replace(/\s+/g, "_");
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            setError(e.message || "No se pudo descargar el archivo");
        }
    };

    

    const formatFecha = (v) => {
        if (!v) return "";
        // Puede venir como ISO (metadata.fecha) o Date string (uploadDate)
        const d = new Date(v);
        if (Number.isNaN(d.getTime())) return String(v);
        return d.toLocaleDateString();
    };

    return (
        <div className="regs-wrap">
            <header className="regs-header">
                <h1>Reglamentos</h1>                
            </header>

            {error && <div className="regs-error">{error}</div>}

            <section className="regs-list">
                {lista.length === 0 && <div className="regs-empty">No hay documentos</div>}
                {lista.map((it) => (
                    <article key={it._id} className="regs-item">
                        <div className="info">
                            <div className="title">{it.nombre || it.mostrar || it.filename}</div>
                            <div className="meta">
                                <span>{(it.length / 1024).toFixed(1)} KB</span>
                                <span>•</span>
                                <span>{formatFecha(it.fecha || it.uploadDate)}</span>
                            </div>
                        </div>
                        <div className="actions">
                            <button className="btn-view" onClick={() => descargar(it)}>
                                Descargar
                            </button>                           
                        </div>
                    </article>
                ))}
            </section>
        </div>
    );
}

export default Reglamentos;
